// ─────────────────────────────────────────────────────────────────────────────
// loadout — a "barra de batalha" (8 slots) que o jogador monta com feitiços e
// itens. Compartilhada entre a CommandBar (dentro do combate) e o
// LoadoutConfigModal (fora do combate: Hub / dashboard). Persistida em
// localStorage por classe.
// ─────────────────────────────────────────────────────────────────────────────

export const LOADOUT_SLOTS = 8;

export type LoadoutSlot = { kind: 'spell' | 'item'; id: string } | null;

export function loadoutKeyFor(classSlug: string | undefined | null): string {
  return `combat.loadout.${classSlug || 'default'}`;
}

export function loadLoadout(key: string): LoadoutSlot[] {
  try {
    const raw = localStorage.getItem(key);
    if (raw) {
      const arr = JSON.parse(raw) as LoadoutSlot[];
      if (Array.isArray(arr)) {
        const norm = arr.slice(0, LOADOUT_SLOTS);
        while (norm.length < LOADOUT_SLOTS) norm.push(null);
        return norm;
      }
    }
  } catch { /* ignore */ }
  return new Array(LOADOUT_SLOTS).fill(null);
}

export function saveLoadout(key: string, slots: LoadoutSlot[]): void {
  try { localStorage.setItem(key, JSON.stringify(slots)); } catch { /* ignore */ }
}

/** Loadout padrão: feitiços primeiro, depois itens, até encher os 8 slots. */
export function defaultLoadout(
  spellIds: string[],
  itemIds: string[],
): LoadoutSlot[] {
  const next: LoadoutSlot[] = new Array(LOADOUT_SLOTS).fill(null);
  let i = 0;
  for (const id of spellIds) { if (i >= LOADOUT_SLOTS) break; next[i++] = { kind: 'spell', id }; }
  for (const id of itemIds) { if (i >= LOADOUT_SLOTS) break; next[i++] = { kind: 'item', id }; }
  return next;
}
